import { h, Component } from 'preact';

import LoadingSpinner from '../spinner/LoadingSpinner';

class AsyncComponent extends Component {
	state = {
		Cmp: null,
		pastDelay: false
	};

	getComponent = async () => {
		if (!this.state.Cmp) {
			try {
				const { default: Cmp } = await this.props.load();

				this.setState({ Cmp });
			}
			catch (e) {
				console.error(e);
			}
		}
	};

	componentDidMount() {
		this.delay = setTimeout(() => {
			this.setState({ pastDelay: true });
		}, 200);

		this.getComponent();
	}

	componentWillUnmount() {
		clearTimeout(this.delay);
	}

	render(props, { Cmp, pastDelay }) {
		return Cmp
			? <Cmp {...props} />
			: pastDelay && <LoadingSpinner isFullPage />;
	}
}

export default AsyncComponent;



// WEBPACK FOOTER //
// ./components/AsyncComponent/index.js